import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { ErrorBoundary } from '@grc/ui-package';
import { I18nProvider } from './stores/settings/language-context';
import { useCarrierPortalGlobalStore } from './stores/carrier-portal-global-store';
import { CarrierPortalGlobalStoreProvider } from './stores/carrier-portal-global-store';
import Layout from './pages/layout';
import { SettingsMenuProvider } from './contexts/settings/setting-menu-header-context';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'devextreme/dist/css/dx.light.css';
import './common/styles/global.scss';
import './app.scss';

export default function App() {
  const [selectedLanguage] = useCarrierPortalGlobalStore(
    store => store.store.selectedLanguage
  );
  //const { changeLanguage } = useDispatchActions();
  const { isLoading, loginWithRedirect, user, error } = useAuth0();

  useEffect(() => {
    (async function login() {
      if (!isLoading && !user) {
        await loginWithRedirect();
      }
    })();

    //if (localStorage.getItem('selectedLanguageKey'))
    // changeLanguage(localStorage.getItem('selectedLanguageKey'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  return (
    <div>
      <ErrorBoundary componentName="carrier-portal">
        <I18nProvider languageKey={selectedLanguage}>
          <CarrierPortalGlobalStoreProvider>
            <SettingsMenuProvider>
              {!user ? <></> : <Layout />}
            </SettingsMenuProvider>
          </CarrierPortalGlobalStoreProvider>
          {/* <MenuProvider>
            <SettingsMenuProvider>
              <Layout />
            </SettingsMenuProvider>
          </MenuProvider> */}
        </I18nProvider>
      </ErrorBoundary>
    </div>
  );
}
